import 'isomorphic-fetch';

import { receiveGlobalMeta, getCacheBuster } from 'Actions/MetaActions';
import { getFetchConfig } from 'Actions/GlobalMetaActions';
import { getLoadingBehavior, shouldNotUpdateState, updatePagesResult, fetchSuccess } from 'Actions/InfiniteScrollActions';
import { setLastGlobalAction, setGlobalNotification, backInHistory } from 'Actions/GlobalMetaActions';
import { displayNotification } from 'Actions/UiActions';
import { getPageSize } from 'Actions/UserSettingsActions';
import { responseNormalizer, updateUstate } from 'Actions/responseNormalizer';
import { trackGAEvent } from 'Actions/adsActions';

import {
	requestForum,
	receiveForum,
	failedForum,
	updateForumFollow,
	updateThreadFollow
} from 'Common/actions/ForumviewActions';

export * from 'Common/actions/ForumviewActions';

export function fetchForum( forumRequest, cacheBust = false ) {

	return function(dispatch, getState) {
		forumRequest.loadingBehavior = getLoadingBehavior(getState, forumRequest.id, "forum", forumRequest.page, forumRequest.forceRefresh);

		if ( shouldNotUpdateState(getState,forumRequest) ) {
			dispatch(updatePagesResult(forumRequest.page||1));
			return null
		}

		dispatch(requestForum(forumRequest));

		const state = getState();
		const url = state.topifyPresets.forumSite.url;

		let userID = state.ustate.id ? state.ustate.id : 0;

		// get fetchConfig
		let fetchConfig = dispatch( getFetchConfig( cacheBust ) );

		let cacheBustQueryString = '&_=' + ( cacheBust ? cacheBust : ( getCacheBuster( getState ) || 0 ) ),
			page_size = dispatch( getPageSize() );

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }&req=cat&id=${forumRequest.id}&pagesize=${page_size}&page=${forumRequest.page}&lb=1${ cacheBustQueryString }`, fetchConfig )
			.then( (response) => {
				if (!response.ok) {
					try {
						response.json().then((json) => {
							setGlobalNotification( dispatch, json, response );
						});
					} catch( e ) {
						setGlobalNotification( dispatch, {}, response );
					}

					dispatch(failedForum(forumRequest, 'Bad response from server'));
					dispatch( backInHistory() );

				} else {
					response.json()
						.then((json) => {
							setGlobalNotification(dispatch,json,{ok: true});

							let other = Object.assign( {}, { page: forumRequest.page }, json.topic ? json.topic.meta : {} );

							let result = responseNormalizer( json, forumRequest.page, other );

							const forumTitle = state.topifyPresets.forumSite.f_title;

							if( json.topic && json.topic.meta.path.length ) {
								dispatch(receiveGlobalMeta(json.topic.meta, json.topic.meta.path[0].title, forumTitle));
							} else {
								dispatch(receiveGlobalMeta(null, forumTitle));
							}

							dispatch( updateUstate( json, result ) );

							const forumview = state.forumview;

							if(forumview.earliestLoadedPage === null || result.page < forumview.earliestLoadedPage) {
								result.earliestLoadedPage = result.page;
							}

							if(forumview.latestLoadedPage === null || result.page > forumview.latestLoadedPage) {
								result.latestLoadedPage = result.page;
							}

							dispatch(fetchSuccess(forumRequest.id, "forum", forumRequest.page, result.totalPages, forumRequest.loadingBehavior));
							dispatch(receiveForum(forumRequest, result));
						}
					)
				}
			}
		).then(()=>{
			setLastGlobalAction('forum',forumRequest);

		}).catch( (error) => {
			setGlobalNotification(dispatch,{},error);
			dispatch(failedForum(forumRequest, 'Bad response from server'));
			dispatch( backInHistory() );
		});
	};
}

export function updateFollowing(data) {
	let subID, subState, subType;
	if (typeof data.forum !== 'undefined' ) {
		subID = data.forum.id;
		subState = data.forum.isSubscribed ? 0 : 1;
		subType = 'Forum';
	} else { //TODO - throw error if typeof data.thread is also undefined?
		subID = data.thread.id;
		subState = data.thread.isSubscribed ? 0 : 1;
		subType = 'Topic';
	}
	let subResponse = subState ? 'followed' : 'unfollowed';

	return (dispatch, getState) => {
		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			body = `type=sub&${ subType.toLowerCase() }=${subID}&state=${subState}`,
			config = dispatch( getFetchConfig( true, 'POST', body ) );

		switch( subType ) {
			case 'Forum':
				dispatch( updateForumFollow( subID, !!(subState) ) );
				break;
			case 'Topic':
				dispatch( updateThreadFollow( subID, !!(subState) ) );
				break;
		}

		return fetch(`${url}?v=3.0&ajax=1&uid=${data.ustate.id}&req=post`, config)
		.then( response => {
			if (!response.ok) {
				try {
					response.json().then((json) => {
						setGlobalNotification( dispatch, json, response );
					});
				} catch( e ) {
					setGlobalNotification( dispatch, {}, response );
				}

				switch( subType ) {
					case 'Forum':
						dispatch( updateForumFollow( subID, !(subState) ) );
						break;
					case 'Topic':
						dispatch( updateThreadFollow( subID, !(subState) ) );
						break;
				}

			} else {
				response.json().then( json => {
					if( subState ) {
						// Record the Google Analytics event and for the forum.
						dispatch( trackGAEvent( true, `follow${ subType }`, 'userAction', 'consumption' ) );
					} else {
						// Record the Google Analytics event.
						dispatch( trackGAEvent( false, `unfollow${ subType }`, 'userAction', 'consumption' ) );
					}

					// Updating state with the returned value
					switch( subType ) {
						case 'Forum':
							dispatch( updateForumFollow( subID, json.result ) );
							break;
						case 'Topic':
							dispatch( updateThreadFollow( subID, json.result ) );
							break;
					}

					if( json.result !== !!(subState) ) {
						displayNotification( 'warning', `The ${subType} is ${subResponse}`, { timeout: 1500 } );
					}
				});
			}
		});
	};
}




// WEBPACK FOOTER //
// ./src/actions/ForumviewActions.js